/**
 *  基于 axios 进行封装
 *  @author lmin
 *  @date 2019-09-03
 */
import axios from 'axios'
// // import { Notice,Modal } from 'view-design';
// import router from '@/router';
// import util from './utils/utils'

// axios.defaults.baseURL="http://192.168.1.163:8007/"
// axios.defaults.baseURL="https://www.zhongsituo.com"
if (process.env.NODE_ENV == 'development') {
    // axios.defaults.baseURL = 'http://192.168.3.163:8007';
    // axios.defaults.baseURL = 'http://192.168.3.165:8007';//九剑
    // axios.defaults.baseURL = 'https://api.zhongsituo.com';
    axios.defaults.baseURL = 'https://api.zstnb.cn:18081';

	// axios.defaults.baseURL = 'https://dev.api.zstnb.cn:18081';
} else if (process.env.NODE_ENV == 'test') {
    // axios.defaults.baseURL = 'http://192.168.3.164:8007';
    axios.defaults.baseURL = 'https://api.zstnb.cn:18081';
    // axios.defaults.baseURL = 'https://api.zhongsituo.com';


} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = 'https://api.zhongsituo.com';
}
// console.log('process.env.NODE_ENV :>> ', process.env.NODE_ENV);
axios.defaults.withCredentials=true
axios.defaults.timeout = 30000;


axios.defaults.headers["Access-Control-Allow-Origin"]="*";
// http request 拦截器
axios.interceptors.request.use(
    config => {
        if (localStorage.getItem('access_token')!=null && localStorage.getItem('access_token')!='') {
            config.headers['Authorization']='Bearer ' + localStorage.getItem('access_token');
        }
        return config
    },
    err => {
        return Promise.reject(err)
    },
)

export const inArray=function (search) {
    let array=[401,102001,102002];
    for(let i in array){
        if(array[i]==search){
            return true;
        }
    }
    return false;
}

/**
 * 异步请求调用封装
 * @param url 请求地址
 * @param data 请求参数
 * @param type 请求方式
 * @param responseType 结果返回类型
 * @returns {Promise<any>}
 */
export default function ajax (url, data={}, type='GET',responseType='') {
    return new Promise(function (resolve, reject) {
        // 执行异步ajax请求
        let promise
        if (type === 'GET') {
            let dataStr = ''
            if(process.env.GRAY_VERSION!='-1'){
                dataStr = '_gray_version='+process.env.GRAY_VERSION+'&'
            }
            Object.keys(data).forEach(key => {
                dataStr += key + '=' + data[key] + '&'
            })
            if (dataStr !== '') {
                dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
                url = url
            }
            if(responseType=='') {
                promise = axios.get(url,{params:data})
            }else {
                promise = axios({
                    method: 'get',
                    url: url,
                    responseType: responseType
                })
            }
        } else {
            if(process.env.GRAY_VERSION!='-1') {
                url = url
            }
            promise = axios.post(url, data)
        }
        promise.then(function (response) {
            resolve(response.data)
        }).catch(function (error) {
            reject(error)
        })
    })
}



